import Machine from '@/models/Machine/Machine';

export default class MachineFilter {

	constructor() {
	/*APP_FILTER_DEFINITION*/
		this.id = '';
		this.code = '';
		this.name = '';
		this.tonase = '';
		this.productionControlTimeId  = '';
		this.productionControlTimeName = '';
		this.sph = '';
		this.lineCodeId  = '';
		this.lineCodeCode = '';
		this.remarkMultiple = '';
		this.isFromUpload = false;
		this.isSavedToBackend = false;
		this.draftFromUpload = '';
		this.draftMode = '';
	/*END_APP_FILTER_DEFINITION*/
		this.exactType = {
	/*APP_APP_FILTER_CRITERIA*/
			id : '0',
			code : '0',
			name : '0',
			tonase : '0',
			productionControlTimeId : '0',
			productionControlTimeName : '0',
			sph : '0',
			lineCodeId : '0',
			lineCodeCode : '0',
			remarkMultiple : '0',
			isFromUpload : '0',
			isSavedToBackend : '0',
	/*END_APP_FILTER_CRITERIA*/
		};
	}

}